module.exports = __webpack_public_path__ + "img/BackLogo.c0e84849.svg";